module.exports = __webpack_public_path__ + "img/repartidor.f16feffb.png";